import { render, staticRenderFns } from "./listComment.vue?vue&type=template&id=03448880&scoped=true"
import script from "./listComment.vue?vue&type=script&lang=js"
export * from "./listComment.vue?vue&type=script&lang=js"
import style0 from "./listComment.vue?vue&type=style&index=0&id=03448880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03448880",
  null
  
)

export default component.exports